export enum ObjectModelPermissionType {
  Action = 1,
  Property = 2,
  Relationship = 3,
}